import React from "react";
import { Modal } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const UploadDocumentModal = ({ open, visible, onCancel, isViewMode, displayDocuments = [], onUpload }) => {
  const isOpen = open ?? visible;
  return (
    <Modal zIndex={2000} getContainer={false} open={isOpen} footer={null} width={600} onCancel={onCancel}>
      <div
        style={{
          fontSize: "22px",
          fontWeight: 600,
          marginBottom: "20px",
        }}
      >
        Uploaded Documents
      </div>

      {/* Upload button only in EDIT MODE */}
      {!isViewMode && (
        <label
          style={{
            border: "1px solid #d9d9d9",
            padding: "6px 16px",
            borderRadius: "4px",
            cursor: "pointer",
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            background: "#fff",
            fontSize: "14px",
            marginBottom: "12px",
          }}
        >
          Upload
          <input
            type="file"
            accept=".jpg,.jpeg,.png,.pdf"
            style={{ display: "none" }}
            onChange={(e) => onUpload(e, "Customer Document")}
          />
        </label>
      )}

      {/* Document list */}
      {displayDocuments.length > 0 ? (
        <div
          style={{
            marginTop: "10px",
            maxHeight: "220px",
            overflowY: "auto",
            border: "1px solid #f0f0f0",
            borderRadius: "6px",
            padding: "10px",
          }}
        >
          {displayDocuments.map((doc, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #e5e7eb",
                padding: "12px",
                borderRadius: "6px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "10px",
                background: "#fafafa",
              }}
            >
              <span
                style={{
                  fontSize: "14px",
                  color: "#333",
                  wordBreak: "break-all",
                }}
              >
                {doc.fileName}
              </span>

              <EyeOutlined style={{ cursor: "pointer" }} onClick={() => window.open(doc.docUrl)} />
            </div>
          ))}
        </div>
      ) : (
        <div style={{ color: "#888" }}>No documents uploaded</div>
      )}
    </Modal>
  );
};

export default UploadDocumentModal;
